
// src/web/components/unread-diaries-card.jsx

import React from 'react'
import { themr } from 'react-css-themr'
import diaryTheme from './themes/diary.css'
import connect from '../../connects/unread-diaries-card'
import {
  Card,
  CardActions
} from 'react-toolbox/lib/card'
import {
  Button,
} from 'react-toolbox/lib/button'

@themr('Diary', diaryTheme)
class UnreadDiariesCard extends React.Component {
  render() {
    const {
      t,
      theme,
      group,
      showUnreadTimeline,
      flushUnreads,
      unreadCount,
    } = this.props

    if (!unreadCount)
      return null

    return (
      <Card theme={theme}>
        <CardActions>
          <div style={{ display: 'flex', width: '100%' }}>
            <div style={{ flexGrow: 1, lineHeight: '36px' }}>
              {unreadCount < 10 && t('label:未読の投稿があります', { unreadCount }) || t('label:未読の投稿がたくさんあります')}
            </div>
            <Button raised label={t('label:すべて開封にする')} onClick={flushUnreads} />
            <Button raised primary label={t('label:未読の投稿を開く')} onClick={showUnreadTimeline} />
          </div>
        </CardActions>
      </Card>
    )
  }
}

export const RawUnreadDiariesCard = UnreadDiariesCard
export default connect(UnreadDiariesCard)



// WEBPACK FOOTER //
// ./src/web/components/unread-diaries-card.jsx